import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelectionList, MatInput, MatDialog } from '@angular/material';
import { FsService } from '../../../fs.service';
import { ShiftsService } from '../../../shifts.service';
import { SelectionModel } from '@angular/cdk/collections';
import { InspectorService } from '../../../inspector.service';
import { PositionService } from '../../../position.service';
import { PositionAssignmentsService } from '../../../position-assignments.service';
import { Shift } from '../../../shift';
import { SitesService } from '../../../sites.service';
import { TransactionService } from '../../../transaction.service';
import { ThemeService } from 'src/app/theme.service';
// import { Observable, Subject } from 'rxjs';
// import { Inspector } from 'src/app/inspector';

@Component({
  selector: 'app-add-inspector',
  templateUrl: './add-inspector.component.html',
  styleUrls: ['./add-inspector.component.scss']
})
export class AddInspectorComponent implements OnInit {

  columns: any = ['name'];
  ogFss: any[];
  fss: any[] = [];
  insps: any = [];
  inspOg: any = [];
  shifts: any = [];
  selectedInsp: any = [];
  siteName = '';
  siteId = '';
  positionId = '';
  item: any;
  ppeInfo = 'test';
  selectedShift: Shift = new Shift();
  agencyRequirements = '';
  @ViewChild(MatSelectionList) inspMatList: MatSelectionList;
  startTime = '';
  endTime = '';
  loading = true;

  skeletonBackgroundColor = `${this.themeService.themeValues.background}cc`;

  constructor(
    public dialogRef: MatDialogRef<AddInspectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fsService: FsService,
    private shiftService: ShiftsService,
    private inspectorService: InspectorService,
    private positionService: PositionService,
    private positionAssignmentService: PositionAssignmentsService,
    private sitesService: SitesService,
    public dialog: MatDialog,
    private transactionService: TransactionService,
    public themeService: ThemeService
  ) { }

  ngOnInit() {
    this.siteName = this.data.siteName;
    this.siteId = this.data.siteId;
    this.item = this.data.item;
    this.positionId = this.item.id;
    this.selectedShift = this.data.selectedShift;
    this.inspMatList.selectedOptions = new SelectionModel(false);
    this.startTime = this.selectedShift.start;
    this.endTime = this.selectedShift.end;
    this.insps = [];
    this.getInspectors();
    this.getShifts(this.siteName);
    this.getSupervisors(this.siteName);
    this.getAgencyRequirements(this.siteName);
  }


  getSupervisors(site: string) {
    this.fsService.getSupervisors(site)
      .subscribe((data) => {
        for ( const fs of data) {
          if (fs.shift === this.selectedShift.name) {
            this.fss.push(fs);
          }
        }
    });
  }

  getInspectors() {
    this.inspectorService.getInspectorList()
      .subscribe((data) => {
        this.inspOg = data;
        this.loading = false;
    });
  }

  getShifts(site: string) {
    this.shiftService.getShifts(site)
      .subscribe((data) => {
        this.shifts = data;
      });
  }

  getAgencyRequirements(site: string) {
    this.sitesService.getAgencyRequirements(site)
      .subscribe((data) => {
        this.agencyRequirements = data[0].agencyRequirements;
        this.agencyRequirements = this.agencyRequirements.replace(/(\r\n|\n|\r)/g, '<br />');
      }
    );
  }

  assignToAgencyClicked() {
    this.dialogRef.close({result: 'agencyClicked'});
  }

  addClicked() {
    if (this.selectedInsp.length === 0) {
      alert('You must select an Inspector to allocate');
      return;
    } else if (this.startTime === '') {
      alert('You must enter a start time');
      return;
    } else if (this.endTime === '') {
      alert('You must enter an end time');
      return;
    }
    this.saveInsp();
  }

  closeClicked() {
    this.dialogRef.close();
  }

  applyInspFilter(filterValue: string) {
    if (this.loading) {
      return;
    }
    if (filterValue.length >= 3) {
      this.insps = this.inspOg;
      const valAr = filterValue.split(' ');
      this.insps = Object.assign([], this.inspOg).filter(
        item => {
          let hit = 0;
          valAr.forEach(term => {
            const itemText = (item.affiliate.trim() + ' ' + item.name.trim()).toLowerCase();
            if (itemText.includes(term.toLowerCase()) || item.id.toString().includes(term)) {
              hit++;
            }
          });
          if (hit === valAr.length) {
            return true;
          } else {
            return false;
          }
        }
      );
      // this.insps = this.inspOg;
      // const filterValueClean = filterValue.trim().toLocaleLowerCase();
      // this.insps = Object.assign([], this.inspOg).filter(
      //   item => {
      //     const itemDetails = item.affiliate.trim() + ' ' + item.name.trim();
      //     return itemDetails.toLocaleLowerCase().includes(filterValueClean)
      //   }
      // );
      // console.log(this.insps)
    } else {
      this.insps = [];
    }
  }

  assignInsp(inspector: any) {
    if (this.inspMatList.selectedOptions.selected.length === 0) {
      this.selectedInsp = [];
    } else {
      this.selectedInsp = [inspector];
    }
  }

  saveInsp() {
    if (this.item.isRequested === 1) {
      this.positionAssignmentService.updatePositionAssignment(this.positionId, '0', this.selectedInsp[0].id, '0',
        localStorage.getItem('userFullName'))
        .subscribe((data) => {
          if (data.length === 0) {
            this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
              'Inspector ' + this.selectedInsp[0].name + ' assigned to the ' + this.selectedShift.name + ' shift at ' + this.siteName)
              .subscribe((tdata) => {
                if (this.item.status === 0) { // if it's empty
                  this.dialogRef.close({
                    result: 'update-inspector',
                    data: this.selectedInsp[0],
                    startTime: this.startTime,
                    endTime: this.endTime
                  });
                } else {
                  this.dialogRef.close({ startTime: this.startTime, endTime: this.endTime }); // trigger a refresh
                }
              }
            );
          } else {
            alert('Something went wrong');
            this.dialogRef.close({result: 'error'});
          }
        });
    } else {
      this.positionAssignmentService.addPositionAssignment(this.positionId, '0', this.selectedInsp[0].id, '0', localStorage.getItem('userFullName'))
        .subscribe(([data]: any) => { // [data] would be data[0]
          this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
            'Inspector ' + this.selectedInsp[0].name + ' assigned to the ' + this.selectedShift.name + ' shift at ' + this.siteName)
            .subscribe((tdata) => {
              if (this.item.status === 0) { // if it's empty
                this.dialogRef.close({
                  result: 'confirm-inspector',
                  data: this.selectedInsp[0],
                  assignmentId: data.id,
                  startTime: this.startTime,
                  endTime: this.endTime
                });
              } else {
                this.dialogRef.close({ startTime: this.startTime, endTime: this.endTime }); // trigger a refresh
              }
            }
          );
        }
      );
    }
    this.positionService.updatePositionFilled(this.positionId, '1', this.startTime, this.endTime, localStorage.getItem('userFullName'))
      .subscribe((data) => {
        if (data.length === 0) {

        } else {
          alert('Something went wrong');
          this.dialogRef.close({result: 'error'});
        }
      }
    );
    // this.dialogRef.close({result: 'success'});
  }

  requestInspector() {
    this.positionAssignmentService.requestInspector(
      this.positionId, '0', localStorage.getItem('userFullName'), this.selectedInsp[0].id, this.selectedInsp[0].name
    )
      .subscribe(([data]: any) => { // [data] would be data[0]
        // Update Start and End Time for the position
        this.positionService.updatePositionFilled(this.positionId, '0', this.startTime, this.endTime, localStorage.getItem('userFullName'))
        .subscribe((updatedPositionData) => {
          if (updatedPositionData.length === 0) {
            this.transactionService.addTransaction(
              localStorage.getItem('userFullName'),
              this.siteId,
              this.selectedShift.name,
              'Inspector ' + this.selectedInsp[0].name + ' requested for the ' + this.selectedShift.name + ' shift at ' + this.siteName
            )
              .subscribe((tdata) => {
                if (this.item.status === 0) { // if it's empty
                  this.dialogRef.close({
                    result: 'request-inspector',
                    data: this.selectedInsp[0],
                    assignmentId: data.id,
                    startTime: this.startTime,
                    endTime: this.endTime
                  });
                } else {
                  // trigger a refresh
                  this.dialogRef.close({ startTime: this.startTime, endTime: this.endTime });
                }
              }
            );
          } else {
            alert('Something went wrong');
            this.dialogRef.close({result: 'error'});
          }
        }
      );
    });
  }

}
